import createIcon from '../../createIcon';

/**
 * @component @name SportsGolf
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTZDMTUuODcgMTYgMTkgMTIuODcgMTkgOUMxOSA1LjEzIDE1Ljg3IDIgMTIgMkM4LjEzIDIgNSA1LjEzIDUgOUM1IDEyLjg3IDguMTMgMTYgMTIgMTZaTTEyIDRDMTQuNzYgNCAxNyA2LjI0IDE3IDlDMTcgMTEuNzYgMTQuNzYgMTQgMTIgMTRDOS4yNCAxNCA3IDExLjc2IDcgOUM3IDYuMjQgOS4yNCA0IDEyIDRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAgOUMxMC41NTIzIDkgMTEgOC41NTIyOCAxMSA4QzExIDcuNDQ3NzIgMTAuNTUyMyA3IDEwIDdDOS40NDc3MiA3IDkgNy40NDc3MiA5IDhDOSA4LjU1MjI4IDkuNDQ3NzIgOSAxMCA5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0IDlDMTQuNTUyMyA5IDE1IDguNTUyMjggMTUgOEMxNSA3LjQ0NzcyIDE0LjU1MjMgNyAxNCA3QzEzLjQ0NzcgNyAxMyA3LjQ0NzcyIDEzIDhDMTMgOC41NTIyOCAxMy40NDc3IDkgMTQgOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiA3QzEyLjU1MjMgNyAxMyA2LjU1MjI4IDEzIDZDMTMgNS40NDc3MiAxMi41NTIzIDUgMTIgNUMxMS40NDc3IDUgMTEgNS40NDc3MiAxMSA2QzExIDYuNTUyMjggMTEuNDQ3NyA3IDEyIDdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNyAxOUg5QzEwLjEgMTkgMTEgMTkuOSAxMSAyMVYyMkgxM1YyMUMxMyAxOS45IDEzLjkgMTkgMTUgMTlIMTdWMTdIN1YxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsGolf = createIcon('SportsGolf', [
  [
    'path',
    {
      d: 'M12 16C15.87 16 19 12.87 19 9C19 5.13 15.87 2 12 2C8.13 2 5 5.13 5 9C5 12.87 8.13 16 12 16ZM12 4C14.76 4 17 6.24 17 9C17 11.76 14.76 14 12 14C9.24 14 7 11.76 7 9C7 6.24 9.24 4 12 4Z',
      key: '18v3vz',
    },
  ],
  [
    'path',
    {
      d: 'M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9Z',
      key: '1teaqt',
    },
  ],
  [
    'path',
    {
      d: 'M14 9C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9Z',
      key: '1vbybr',
    },
  ],
  [
    'path',
    {
      d: 'M12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z',
      key: 'pu5z47',
    },
  ],
  [
    'path',
    {
      d: 'M7 19H9C10.1 19 11 19.9 11 21V22H13V21C13 19.9 13.9 19 15 19H17V17H7V19Z',
      key: '17d9w0',
    },
  ],
]);

export default SportsGolf;
